import BaseService from "@/services/baseService";
import CryptoJS from "crypto-js";

export default class AuthService extends BaseService {
    static async tokenApi() {
        let cryptCredentials = CryptoJS.AES.encrypt(
            process.env.VUE_APP_CLIENT_CREDENTIALS,
            process.env.VUE_APP_PASSPHRASE
        ).toString();
        return await this.perfom({
            url: "/api/v2.0/appecupt/auth/token",
            method: "POST",
            headers: {
                "client_credentials": cryptCredentials,
            }
        });
    }
    static async riceviTokenSpid(body) {
        return await this.perfom({
            url: "/oidc/token",
            method: "POST",
            body:body
        });
    }

    static async encryptToken(token, idToken){
        return await this.perfom({
            url: "/oidc/token/encrypt",
            method: "POST",
            body:{
                access_token: token,
                id_token: idToken
            }
        })
    }

    static async verificaTokenSpid(accessToken) {
        return await this.perfom({
            url: "/api/v2.0/appecupt/auth/datispid",
            method: "POST",
            headers: {
                "access_token": accessToken,
            }
        });
    }

    static async login(accessToken) {
        return await this.perfom({
            url: "/api/v2.0/appecupt/auth/login",
            method: "POST",
            headers: {
                "access_token": accessToken,
            }
        });
    }
    static async loginDemo() {
        return await this.perfom({
            url: "/api/v2.0/appecupt/auth/login",
            method: "POST",
            headers: {
                "access_token": "",
            },
            body:{
                username:'demo',
                password:'Ventordici1'
            }
        });
    }
    static async registrazione(utente,accessTocken) {
        return await this.perfom({
            url: "/api/v2.0/appecupt/auth/registrazione",
            method: "POST",
            headers: {
                access_token:accessTocken
            },
            body: utente
        });
    }

    static async anagraficaUtente(accessToken,tentativo=0) {
        const response =  await this.perfom({
            url: "/api/v2.0/appecupt/auth/prelevaAnagraficaUtente",
            method: "GET",
            headers: {
                "access_token": accessToken,
            }
        });
        if(response.status === 401 && tentativo<3){
            return await AuthService.anagraficaUtente(accessToken,tentativo+1)
        }
        else if(response.status === 401 && tentativo>=3)
        {
            sessionStorage.clear()
            await window.alert("sessione scaduta, rieffettuare l'accesso")
            window.location.reload();
            return response
        }
        else
            return response;
    }

    static async modificaAnagraficaUtente(utente,tentativo=0) {
        const response =  await this.perfom({
            url: "/api/v2.0/appecupt/auth/modAssistito",
            method: "POST",
            headers: {},
            body: utente
        });
        if(response.status === 401 && tentativo<3){
            return await AuthService.modificaAnagraficaUtente(utente,tentativo+1)
        }
        else if(response.status === 401 && tentativo>=3)
        {
            sessionStorage.clear()
            await window.alert("sessione scaduta, rieffettuare l'accesso")
            window.location.reload();
            return response
        }
        else
            return response;
    }

    static async eliminaAccount(tentativo=0) {
        const response =   await this.perfom({
            url: "/api/v2.0/appecupt/auth/eliminaaccount",
            method: "POST",
            headers: {},
        });
        if(response.status === 401 && tentativo<3){
            return await AuthService.eliminaAccount(tentativo+1)
        }
        else if(response.status === 401 && tentativo>=3)
        {
            sessionStorage.clear()
            await window.alert("sessione scaduta, rieffettuare l'accesso")
            window.location.reload();
            return response
        }
        else
            return response;
    }

    static async richiestaDatiAccount(tentativo=0){
        const response = await this.perfom({
            url: "/api/v2.0/appecupt/auth/scaricaAnagrafica",
            method: "GET",
            headers: {},
        });
        if(response.status === 401 && tentativo<3){
            return await AuthService.richiestaDatiAccount(tentativo+1)
        }
        else if(response.status === 401 && tentativo>=3)
        {
            sessionStorage.clear()
            await window.alert("sessione scaduta, rieffettuare l'accesso")
            window.location.reload();
            return response
        }
        else
            return response;
    }
}
